import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
  providers:[MasterService,ClassroomService]
})
export class ResultsComponent implements OnInit {

  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  
  feedtls:any[];
feedmet:any[];
feesum:any={};
    sections:any=[];
    classes:any=[];
    arrstudent:any=[];
    fmodel:any={clid:'0',scid:'0',subid:'0',prid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrashead:any=[];
    arrcourse:any=[];
    arrastype:any=[];
    arrastype1:any=[];
    oprtype:any='';
    tabledata: any = {};
    rcremarks='';
    fileToUpload: File = null;
    arrcat:any=[{name:'Board'},{name:'Competitive'}];

fData: FormData = new FormData;
    constructor(private http: HttpClient,private aservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
  
    ngOnInit(): void {
      this.fmodel.ascat='Board';
      // this.masasshead();
      // this.masasstype();
      this.mascourse();
     

      
     
    }
  
    checknumber(ele) {
      if (ele.score < 0 || ele.score==null  )
      {

        ele.score = 0.00;
      }
      else if (ele.score > ele.maxsc) {
        alert('Marks should be less than or equal to maxscore');
        ele.score = ele.accscore1;
  
        console.log("accscore1", ele.accscore1 + " & " + ele.accscore);
      }
      // else {
      //   ele.accscore = parseFloat(ele.accscore).toFixed(0);
      // }
    }
    masclass() {
      this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.massection();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

    
    massection() {
      this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.scid=resultArray[0].scid;
             // this.masasshead();
             this.getstudentsdata();
          },
          error => console.log("Error :: " + error)
          )
    }

    
 
onchangeasscat()
{
  this.arrashead=this.arrastype1.filter(item => item.ascat===this.fmodel.ascat);
  this.fmodel.assid=this.arrashead[0].asid;
  this.SelectReportDetails();
}
      onclasschange()
      {
        this.massection();
this.getstudentsdata();
      }
  
      SelectReportDetails() {
        
        console.log('model', this.fmodel);
        this.aservice.getresults(this.fmodel)
          .subscribe(resultArray => {
            console.log('ret-select', resultArray);
            this.feedtls=resultArray.Exmresult;
           this.feesum=resultArray.sumary;
          
    
          }, error =>
            alert('error in connection')
          );
    
       
      }


      
      mascourse() {
        this.mservice.mascourse()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcourse = resultArray;
                this.fmodel.crid=resultArray[0].crid;
                this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }
      by_sp_student() {
        debugger
       var dbnm = '';
         var clid = this.fmodel.clid;
         var secid = this.fmodel.secid;
         var brid = '0';
         this.aservice.by_sp_student(clid, secid,brid)
          .subscribe(
          resultArray => {
            console.log('std-result', resultArray);
            this.arrstudent = resultArray;        
          },
          error => console.log("Error :: " + error)
          );
      }

      getstudentsdata() {
        this.aservice.getstudents_clwise(this.fmodel.clid,this.fmodel.scid,this.fmodel.crid)
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);
                this.arrstudent = resultArray;
               this.fmodel.stuid= resultArray[0].stuid;
                this.SelectReportDetails();
            },
            error => console.log("Error :: " + error)
            )
      }


     
      
        
  }
